import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "7",
  viewBox: "0 0 14 7"
}, [
  /*#__PURE__*/_createElementVNode("g", {
    fill: "none",
    "fill-rule": "evenodd",
    opacity: "1"
  }, [
    /*#__PURE__*/_createElementVNode("g", { class: "icon-tilde__graph" }, [
      /*#__PURE__*/_createElementVNode("path", {
        class: "icon-tilde__path",
        d: "M1.243 7L0 5.936 6.998.003 6.999 0 7 .001 7.001 0v.003L14 5.936 12.757 7 7 2.096 1.243 7z",
        transform: "translate(-884.000000, -781.000000) translate(835.000000, 569.000000) translate(20.000000, 20.000000) translate(29.000000, 182.000000) translate(7.000000, 13.500000) rotate(-180.000000) translate(-7.000000, -13.500000) translate(0.000000, 10.000000)"
      })
    ])
  ])
], -1)
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["icon-tilde", { 'icon-tilde--active': _ctx.active }])
  }, _hoisted_2, 2))
}